import React from 'react';

class JobIndustries extends React.Component {
    constructor() {
        super();
        this.state = {
            toggle: false

        }
    }

    render() {

        const {toggle} = this.state;

        const _toggle = toggle ? "item-uncollapsed" : "item-collapsed",
            label = toggle ? "less" : "more",
            faIcon = toggle ? "fa fa-angle-up" : "fa fa-angle-down";

        const {job} = this.props;

        const firstIndustry = job.industries && (job.industries) [0].name;

        const lastIndustry = job.industries && (job.industries ).slice(1);

        const hiddenIndustryNames = lastIndustry && lastIndustry.map((industry, index) => <li key={index}
                                                                              className="job-sector">{industry.name}</li>)

        return (
            <span className={`job-sectors-list-item ${ _toggle }`}>
                <div className="job-sector-list"><p className="p-tag"><b>Industries:</b></p></div>
                        <ul className="item-content">
                            <li className="first-industry">
                               {firstIndustry}
                            </li>
                            {hiddenIndustryNames}
                        </ul>

                {(hiddenIndustryNames && hiddenIndustryNames.length > 0)

                    ? <div className="line">
                        <button className="btn btn-more-less" onClick={() => this.setState({toggle: !toggle})}>
                            <span className="label">{label}</span>
                            <span className="icon"><i className={`${ faIcon } fa-right`}/></span>
                        </button>
                    </div>

                    : null
                }

            </span>
        )
    }
}

export default JobIndustries;


// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/JobIndustries.js